import {setup} from './web-core/src/setup';
import './sass/instance.scss';

import Vue from 'vue';
import Dashboard from './components/Dashboard'

Vue.component('packages-dashboard', Dashboard);

import AppConfig from './config/Config.js';

const url  = window.origin + '/api/';

setup(AppConfig, url);
